/**
 * Public Auth Pages Entrypoint
 *
 * Vite entrypoint loaded by `authentication.html.erb`, the layout shared by
 * every Devise page. It mounts the vanilla-TS behaviours the public forms need
 * - the show/hide toggle on every password field and the password-requirements
 * panel on the new-password page.
 *
 * Deliberately NOT Stimulus: `@hotwired/stimulus` is not in `package.json` and
 * `importmap-rails` is not in the Gemfile, so a `data-controller` attribute
 * would be inert here. A Vite entrypoint is the only pattern that works on
 * these pages, and it mirrors `consent.ts` and `registration.ts`.
 *
 * Mounting is a no-op on auth pages with no password field (password reset
 * request, confirmations, unlocks), and likewise for the requirements panel,
 * which only the new-password page carries.
 */

import { mountPasswordStrength, mountPasswordToggles } from "../app/auth";

function boot(): void {
  mountPasswordToggles(document);
  mountPasswordStrength(document);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
